import { cn } from '@/lib/utils'
import { colors, accent } from '@/lib/tokens'

const sizes = {
  sm: 'w-4 h-4',
  default: 'w-5 h-5',
  lg: 'w-6 h-6',
} as const

function Spinner({
  size = 'default',
  className,
}: {
  size?: keyof typeof sizes
  className?: string
}) {
  return (
    <div
      className={cn('rounded-full border-2 animate-spin', sizes[size], className)}
      style={{ borderColor: colors.accentSubtle, borderTopColor: accent }}
    />
  )
}

export { Spinner }
